<template>
  <div class="products">
    <el-tabs v-model="activeTab" type="border-card" class="products-tabs" @tab-click="handleTabChange">
      <!-- Tab1: 甄选商品上传/编辑 -->
      <el-tab-pane label="甄选商品上传/编辑" name="products">
        <!-- 搜索栏 -->
        <div class="toolbar">
          <div class="toolbar-left">
            <el-input v-model="searchKeyword" placeholder="搜索甄选商品名称/ID" prefix-icon="el-icon-search" size="small"
              style="width: 260px;" clearable @clear="fetchProducts" @keyup.enter.native="fetchProducts" />
            <el-button size="small" @click="fetchProducts">查询</el-button>
          </div>
          <div class="toolbar-right">
            <el-button type="primary" size="small" icon="el-icon-plus"
              @click="openProductDialog('add')">新增甄选商品</el-button>
          </div>
        </div>

        <!-- 表格 -->
        <el-table ref="productTable" :data="productList" style="width: 100%;" border stripe v-loading="productLoading">
          <el-table-column prop="id" label="ID" width="70" />
          <el-table-column label="商品主图" width="90">
            <template slot-scope="scope">
              <el-image :src="scope.row.goods_img || scope.row.image"
                style="width: 56px; height: 56px; border-radius: 4px;" fit="cover"
                :preview-src-list="[scope.row.goods_img || scope.row.image]" />
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称" min-width="180" show-overflow-tooltip />
          <el-table-column label="365n标价" width="100">
            <template slot-scope="scope">
              <span class="price-red">¥{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="库存" width="80" />
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="auditStatusType(scope.row.audit_status || scope.row.status)" size="small">
                {{ auditStatusText(scope.row.audit_status || scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="托管商品" width="90">
            <template slot-scope="scope">
              <el-tag v-if="isCloud(scope.row)" type="success" size="small">已托管</el-tag>
              <span v-else class="no-action">未托管</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="驳回原因/备注" width="140" show-overflow-tooltip />
          <el-table-column label="操作" width="250" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openProductDialog('edit', scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="openDetailDialog(scope.row)">查看详情</el-button>
              <el-button v-if="!isCloud(scope.row)" type="text" size="small" style="color: #67C23A;"
                @click="handleSetCloud(scope.row)">设为托管</el-button>
              <el-button v-else type="text" size="small" style="color: #E6A23C;"
                @click="handleCancelCloud(scope.row)">取消托管</el-button>
              <el-button type="text" size="small" style="color: #F56C6C;"
                @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrap">
          <span>共 {{ productTotal }} 条记录</span>
          <el-pagination background layout="prev, pager, next" :total="productTotal" :page-size="productLimit"
            :current-page.sync="productPage" @current-change="fetchProducts" />
        </div>
      </el-tab-pane>

      <!-- Tab2: 跨供应链选品库 -->
      <el-tab-pane label="跨供应链选品库" name="selection">
        <!-- 内部二级 Tab -->
        <div class="sub-tabs">
          <el-radio-group v-model="selectionSubTab" size="small">
            <el-radio-button label="library">选品库</el-radio-button>
            <el-radio-button label="audit">合作申请审核</el-radio-button>
          </el-radio-group>
        </div>

        <!-- 选品库列表 -->
        <div v-show="selectionSubTab === 'library'">
          <!-- 蓝色提示 -->
          <div class="info-banner">
            <i class="el-icon-info"></i>
            <p>
              <strong>跨供应链选品说明：</strong>您可以从其他分身商家的商品库挑选商品，通过协商利润分成比例后申请上架到您的分身商城。上架后产生的订单将由所属商家发货，您获取分成利润。
            </p>
          </div>

          <!-- 表格 -->
          <el-table :data="selectionList" style="width: 100%;" border stripe v-loading="selectionLoading">
            <el-table-column prop="id" label="ID" width="70" />
            <el-table-column prop="goods_name" label="商品名称" min-width="180" show-overflow-tooltip />
            <el-table-column prop="store_name" label="所属分身" width="120" />
            <el-table-column label="原售价" width="100">
              <template slot-scope="scope">
                <span class="price-red">¥{{ scope.row.original_price || scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="selectionStatusType(scope.row.status)" size="small">
                  {{ selectionStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="openApplyDialog(scope.row)"
                  :disabled="scope.row.status === 1">申请上架</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrap">
            <span>共 {{ selectionTotal }} 条记录</span>
            <el-pagination background layout="prev, pager, next" :total="selectionTotal" :page-size="selectionLimit"
              :current-page.sync="selectionPage" @current-change="fetchSelection" />
          </div>
        </div>

        <!-- 合作申请审核 -->
        <div v-show="selectionSubTab === 'audit'">
          <!-- 统计卡片 -->
          <el-row :gutter="24" class="audit-stats">
            <el-col :span="12">
              <div class="audit-stat-card audit-stat-orange">
                <p class="audit-stat-label">待审核申请</p>
                <h3 class="audit-stat-value">{{ auditStats.pendingCount }} 条</h3>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="audit-stat-card audit-stat-green">
                <p class="audit-stat-label">本月合作通过</p>
                <h3 class="audit-stat-value">{{ auditStats.monthApprovedCount }} 条</h3>
              </div>
            </el-col>
          </el-row>

          <!-- 表格 -->
          <el-table :data="applicationList" style="width: 100%;" border stripe v-loading="applicationLoading">
            <el-table-column prop="id" label="申请ID" width="80" />
            <el-table-column prop="applicant_name" label="申请方分身" width="120" />
            <el-table-column prop="goods_name" label="商品名" min-width="160" show-overflow-tooltip />
            <el-table-column label="我方分成" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.our_ratio || scope.row.ourRatio }}%</span>
              </template>
            </el-table-column>
            <el-table-column label="对方分成" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.their_ratio || scope.row.theirRatio }}%</span>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="申请时间" width="160" />
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="applicationStatusType(scope.row.status)" size="small">
                  {{ applicationStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140" fixed="right">
              <template slot-scope="scope">
                <template v-if="scope.row.status === 0">
                  <el-button type="text" size="small" style="color: #67c23a;"
                    @click="handleApprove(scope.row)">通过</el-button>
                  <el-button type="text" size="small" style="color: #F56C6C;"
                    @click="handleReject(scope.row)">驳回</el-button>
                </template>
                <span v-else class="no-action">--</span>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrap">
            <span>共 {{ applicationTotal }} 条记录</span>
            <el-pagination background layout="prev, pager, next" :total="applicationTotal" :page-size="applicationLimit"
              :current-page.sync="applicationPage" @current-change="fetchApplications" />
          </div>
        </div>
      </el-tab-pane>

      <!-- Tab3: 臻赏商品上传/编辑 -->
      <el-tab-pane label="臻赏商品上传/编辑" name="zhenshang">
        <!-- 搜索栏 -->
        <div class="toolbar">
          <div class="toolbar-left">
            <el-input v-model="zhenshangSearchKeyword" placeholder="搜索臻赏商品名称/ID" prefix-icon="el-icon-search"
              size="small" style="width: 260px;" clearable @clear="fetchZhenshangProducts"
              @keyup.enter.native="fetchZhenshangProducts" />
            <el-button size="small" @click="fetchZhenshangProducts">查询</el-button>
          </div>
          <div class="toolbar-right">
            <el-button type="primary" size="small" icon="el-icon-plus"
              @click="openProductDialog('add')">新增臻赏商品</el-button>
          </div>
        </div>

        <!-- 臻赏说明横幅 -->
        <div class="info-banner zhenshang-banner">
          <i class="el-icon-info"></i>
          <p>
            <strong>臻赏专区说明：</strong>本专区商品独立成区（购买赠送消费券、签到等额释放）。供货价必须低于售价的<strong>1折</strong>，商品由总后台审核通过后展示。
          </p>
        </div>

        <!-- 表格 -->
        <el-table ref="zhenshangTable" :data="zhenshangProductList" style="width: 100%;" border stripe
          v-loading="productLoading">
          <el-table-column prop="id" label="ID" width="70" />
          <el-table-column label="商品主图" width="90">
            <template slot-scope="scope">
              <el-image :src="scope.row.goods_img || scope.row.image"
                style="width: 56px; height: 56px; border-radius: 4px;" fit="cover"
                :preview-src-list="[scope.row.goods_img || scope.row.image]" />
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称" min-width="180" show-overflow-tooltip />
          <el-table-column label="售价" width="100">
            <template slot-scope="scope">
              <span class="price-red">¥{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="供货价" width="100">
            <template slot-scope="scope">
              <span>¥{{ scope.row.skus && scope.row.skus[0] ? scope.row.skus[0].cost_price : (scope.row.cost_price || 0)
                }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="库存" width="80" />
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="auditStatusType(scope.row.audit_status || scope.row.status)" size="small">
                {{ auditStatusText(scope.row.audit_status || scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="驳回原因/备注" width="140" show-overflow-tooltip />
          <el-table-column label="操作" width="180" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openProductDialog('edit', scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="openDetailDialog(scope.row)">查看详情</el-button>
              <el-button type="text" size="small" style="color: #F56C6C;"
                @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrap">
          <span>共 {{ zhenshangProductTotal }} 条记录</span>
          <el-pagination background layout="prev, pager, next" :total="zhenshangProductTotal" :page-size="productLimit"
            :current-page.sync="zhenshangProductPage" @current-change="fetchZhenshangProducts" />
        </div>
      </el-tab-pane>

      <!-- Tab4: 爆品商品上传/编辑 -->
      <el-tab-pane label="爆品商品上传/编辑" name="baopin">
        <!-- 搜索栏 -->
        <div class="toolbar">
          <div class="toolbar-left">
            <el-input v-model="baopinSearchKeyword" placeholder="搜索爆品商品名称/ID" prefix-icon="el-icon-search" size="small"
              style="width: 260px;" clearable @clear="fetchBaopinProducts" @keyup.enter.native="fetchBaopinProducts" />
            <el-button size="small" @click="fetchBaopinProducts">查询</el-button>
          </div>
          <div class="toolbar-right">
            <el-button type="primary" size="small" icon="el-icon-plus"
              @click="openProductDialog('add')">新增爆品商品</el-button>
          </div>
        </div>

        <!-- 爆品说明横幅 -->
        <div class="info-banner">
          <i class="el-icon-info"></i>
          <p>
            <strong>爆品专区说明：</strong>本专区商品独立成区，用于特惠走量爆品。爆品展示在首页「爆品专区」，不参与会员晋级/邀请计数，商品由总后台审核通过后展示。
          </p>
        </div>

        <!-- 表格 -->
        <el-table ref="baopinTable" :data="baopinProductList" style="width: 100%;" border stripe
          v-loading="productLoading">
          <el-table-column prop="id" label="ID" width="70" />
          <el-table-column label="商品主图" width="90">
            <template slot-scope="scope">
              <el-image :src="scope.row.goods_img || scope.row.image"
                style="width: 56px; height: 56px; border-radius: 4px;" fit="cover"
                :preview-src-list="[scope.row.goods_img || scope.row.image]" />
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称" min-width="180" show-overflow-tooltip />
          <el-table-column label="365n标价" width="100">
            <template slot-scope="scope">
              <span class="price-red">¥{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="库存" width="80" />
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="auditStatusType(scope.row.audit_status || scope.row.status)" size="small">
                {{ auditStatusText(scope.row.audit_status || scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="驳回原因/备注" width="140" show-overflow-tooltip />
          <el-table-column label="操作" width="180" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openProductDialog('edit', scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="openDetailDialog(scope.row)">查看详情</el-button>
              <el-button type="text" size="small" style="color: #F56C6C;"
                @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrap">
          <span>共 {{ baopinProductTotal }} 条记录</span>
          <el-pagination background layout="prev, pager, next" :total="baopinProductTotal" :page-size="productLimit"
            :current-page.sync="baopinProductPage" @current-change="fetchBaopinProducts" />
        </div>
      </el-tab-pane>

      <!-- Tab5: 托管商品管理 -->
      <el-tab-pane label="托管商品管理" name="cloud">
        <!-- 搜索栏 -->
        <div class="toolbar">
          <div class="toolbar-left">
            <el-input v-model="cloudSearchKeyword" placeholder="搜索托管商品名称/ID" prefix-icon="el-icon-search" size="small"
              style="width: 260px;" clearable @clear="fetchCloudProducts" @keyup.enter.native="fetchCloudProducts" />
            <el-button size="small" @click="fetchCloudProducts">查询</el-button>
          </div>
        </div>

        <!-- 托管说明横幅 -->
        <div class="info-banner cloud-banner">
          <i class="el-icon-info"></i>
          <p>
            <strong>托管商品说明：</strong>托管商品全部来源于<strong>甄选专区</strong>，在「甄选商品上传/编辑」列表中点击「设为托管」即可开通。
            只有已托管的甄选商品才会展示在会员端「云仓」，会员可对其兑换到家或托管售卖；在本页或甄选列表点击「取消托管」后，会员端云仓将不再展示。
          </p>
        </div>

        <!-- 表格 -->
        <el-table :data="cloudProductList" style="width: 100%;" border stripe v-loading="productLoading">
          <el-table-column prop="id" label="ID" width="70" />
          <el-table-column label="商品主图" width="90">
            <template slot-scope="scope">
              <el-image :src="scope.row.goods_img || scope.row.image"
                style="width: 56px; height: 56px; border-radius: 4px;" fit="cover"
                :preview-src-list="[scope.row.goods_img || scope.row.image]" />
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称" min-width="180" show-overflow-tooltip />
          <el-table-column label="365n标价" width="100">
            <template slot-scope="scope">
              <span class="price-red">¥{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="库存" width="80" />
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="auditStatusType(scope.row.audit_status || scope.row.status)" size="small">
                {{ auditStatusText(scope.row.audit_status || scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="托管时间" width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.cloud_time">{{ scope.row.cloud_time }}</span>
              <span v-else class="no-action">-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openDetailDialog(scope.row)">查看详情</el-button>
              <el-button type="text" size="small" style="color: #E6A23C;"
                @click="handleCancelCloud(scope.row)">取消托管</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrap">
          <span>共 {{ cloudProductTotal }} 个托管商品</span>
          <el-pagination background layout="prev, pager, next" :total="cloudProductTotal" :page-size="productLimit"
            :current-page.sync="cloudProductPage" @current-change="fetchCloudProducts" />
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 新增/编辑商品弹窗 -->
    <el-dialog :title="productDialogTitle" :visible.sync="productDialogVisible" width="800px"
      :close-on-click-modal="false" @closed="resetProductForm">
      <el-form ref="productForm" :model="productForm" :rules="productRules" label-width="90px">
        <!-- 基本信息 -->
        <el-divider content-position="left">基本信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="商品名称" prop="goods_name">
              <el-input v-model="productForm.goods_name" placeholder="请输入商品名称" maxlength="200" show-word-limit />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 价格体系 -->
        <el-divider content-position="left">价格体系</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="成本价" prop="cost_price">
              <el-input-number v-model="productForm.cost_price" :min="0" :precision="2" controls-position="right"
                style="width: 100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="售价(365n标价)" prop="price">
              <el-input-number v-model="productForm.price" :min="0" :precision="2" controls-position="right"
                style="width: 100%;" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="原价">
              <el-input-number v-model="productForm.original_price" :min="0" :precision="2" controls-position="right"
                style="width: 100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="库存" prop="stock">
              <el-input-number v-model="productForm.stock" :min="0" controls-position="right" style="width: 100%;" />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 臻赏 1折 校验提示 -->
        <div v-if="currentGoodsType === 3" class="zhenshang-price-tip">
          <i class="el-icon-warning"></i>
          <span>臻赏商品要求：<strong>供货价（成本价）≤ 售价的1折</strong>，否则无法提交（提交时自动校验）。</span>
        </div>

        <!-- 多SKU管理 -->
        <el-divider content-position="left">
          <el-checkbox v-model="skuEnabled" style="margin-right: 8px;">启用多SKU规格</el-checkbox>
        </el-divider>
        <div v-if="skuEnabled" class="sku-section">
          <el-row :gutter="20" style="margin-bottom: 12px;">
            <el-col :span="12">
              <el-input v-model="skuSpecName1" placeholder="规格1名称，如：颜色" size="small">
                <template slot="prepend">规格1</template>
              </el-input>
              <el-input v-model="skuSpecValues1" placeholder="规格值，逗号分隔，如：红色,蓝色" size="small" style="margin-top: 6px;" />
            </el-col>
            <el-col :span="12">
              <el-input v-model="skuSpecName2" placeholder="规格2名称，如：尺寸" size="small">
                <template slot="prepend">规格2</template>
              </el-input>
              <el-input v-model="skuSpecValues2" placeholder="规格值，逗号分隔，如：S,M" size="small" style="margin-top: 6px;" />
            </el-col>
          </el-row>
          <el-button type="primary" size="small" plain @click="generateSkuList">生成SKU列表</el-button>

          <!-- SKU列表表格 -->
          <el-table v-if="productForm.skus.length > 0" :data="productForm.skus" border size="small"
            style="margin-top: 12px;">
            <el-table-column label="规格组合" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.spec_name_text || '默认' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="成本价" width="120">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.cost_price" :min="0" :precision="2" size="small"
                  controls-position="right" style="width: 100%;"
                  @change="(val) => { $set(productForm.skus[scope.$index], 'cost_price', val) }" />
              </template>
            </el-table-column>
            <el-table-column label="售价" width="120">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.price" :min="0" :precision="2" size="small"
                  controls-position="right" style="width: 100%;"
                  @change="(val) => { $set(productForm.skus[scope.$index], 'price', val) }" />
              </template>
            </el-table-column>
            <el-table-column label="原价" width="120">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.original_price" :min="0" :precision="2" size="small"
                  controls-position="right" style="width: 100%;"
                  @change="(val) => { $set(productForm.skus[scope.$index], 'original_price', val) }" />
              </template>
            </el-table-column>
            <el-table-column label="库存" width="120">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.stock" :min="0" size="small" controls-position="right"
                  style="width: 100%;" @change="(val) => { $set(productForm.skus[scope.$index], 'stock', val) }" />
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 商品图片 -->
        <el-divider content-position="left">商品图片</el-divider>
        <el-form-item label="商品主图" prop="goods_img" required>
          <div class="upload-img-section">
            <el-upload class="main-img-uploader" action="https://apighyx.zgyxszds.com/api/v1/supplier/upload"
              :headers="uploadHeaders" :show-file-list="false" :on-success="handleMainImgSuccess"
              :before-upload="beforeUpload" accept="image/*">
              <img v-if="productForm.goods_img" :src="productForm.goods_img" class="main-img-preview" />
              <i v-else class="el-icon-plus main-img-uploader-icon"></i>
            </el-upload>
            <span class="upload-tip">建议尺寸 800×800px，大小不超过5MB</span>
          </div>
        </el-form-item>
        <el-form-item label="轮播图">
          <div class="slide-imgs-section">
            <div v-for="(url, idx) in slideImgList" :key="idx" class="slide-img-item">
              <img :src="url" class="slide-img-preview" />
              <div class="slide-img-actions">
                <i class="el-icon-delete" @click="removeSlideImg(idx)"></i>
              </div>
            </div>
            <el-upload v-if="slideImgList.length < 9" class="slide-img-uploader"
              action="https://apighyx.zgyxszds.com/api/v1/supplier/upload" :headers="uploadHeaders"
              :show-file-list="false" :on-success="handleSlideImgSuccess" :before-upload="beforeUpload"
              accept="image/*">
              <i class="el-icon-plus slide-img-uploader-icon"></i>
            </el-upload>
          </div>
          <span class="upload-tip">可上传多张，建议尺寸 800×800px</span>
        </el-form-item>

        <!-- 商品详情 -->
        <el-divider content-position="left">商品详情</el-divider>
        <el-form-item label="详情图片">
          <div class="detail-imgs-section">
            <div v-for="(url, idx) in detailImgList" :key="idx" class="detail-img-item">
              <img :src="url" class="detail-img-preview" />
              <div class="detail-img-actions">
                <i class="el-icon-delete" @click="removeDetailImg(idx)"></i>
              </div>
            </div>
            <el-upload v-if="detailImgList.length < 20" class="detail-img-uploader"
              action="https://apighyx.zgyxszds.com/api/v1/supplier/upload" :headers="uploadHeaders"
              :show-file-list="false" :on-success="handleDetailImgSuccess" :before-upload="beforeUpload"
              accept="image/*">
              <i class="el-icon-plus detail-img-uploader-icon"></i>
            </el-upload>
          </div>
          <span class="upload-tip">支持多张详情图片，建议宽度750px</span>
        </el-form-item>
        <el-form-item label="上架状态">
          <el-radio-group v-model="productForm.is_putaway">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="productDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="productSubmitting" @click="submitProduct">确定</el-button>
      </div>
    </el-dialog>

    <!-- 查看详情弹窗 -->
    <el-dialog title="商品详情" :visible.sync="detailDialogVisible" width="600px">
      <div class="detail-wrap" v-if="detailData">
        <div class="detail-row">
          <span class="detail-label">商品名称：</span>
          <span>{{ detailData.goods_name }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">365n标价：</span>
          <span class="price-red">¥{{ detailData.price }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">库存：</span>
          <span>{{ detailData.stock }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">审核状态：</span>
          <el-tag :type="auditStatusType(detailData.audit_status || detailData.status)" size="small">
            {{ auditStatusText(detailData.audit_status || detailData.status) }}
          </el-tag>
        </div>
        <div class="detail-row" v-if="detailData.remark">
          <span class="detail-label">驳回原因/备注：</span>
          <span>{{ detailData.remark }}</span>
        </div>
        <div class="detail-row" v-if="detailData.goods_img || detailData.image">
          <span class="detail-label">商品图片：</span>
          <el-image :src="detailData.goods_img || detailData.image"
            style="width: 120px; height: 120px; border-radius: 4px;" fit="cover" />
        </div>
        <div class="detail-row" v-if="detailImages.length > 0">
          <span class="detail-label">商品详情：</span>
          <div class="detail-images-gallery">
            <img v-for="(url, idx) in detailImages" :key="idx" :src="url" class="detail-gallery-img"
              @click="previewDetailImage(url)" />
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 申请上架弹窗 -->
    <el-dialog title="申请上架" :visible.sync="applyDialogVisible" width="500px">
      <el-form v-if="applyTarget" label-width="110px">
        <el-form-item label="商品名称">
          <span>{{ applyTarget.goods_name }}</span>
        </el-form-item>
        <el-form-item label="所属分身">
          <span>{{ applyTarget.store_name }}</span>
        </el-form-item>
        <el-form-item label="原售价">
          <span class="price-red">¥{{ applyTarget.original_price || applyTarget.price }}</span>
        </el-form-item>
        <el-form-item label="我方分成比例" prop="ourRatio">
          <el-input-number v-model="applyForm.ourRatio" :min="0" :max="100" :precision="1" controls-position="right"
            style="width: 160px;" />
          <span style="margin-left: 8px; color: #909399;">%</span>
          <span style="margin-left: 12px; color: #909399; font-size: 12px;">
            （对方分成：{{ (100 - applyForm.ourRatio).toFixed(1) }}%）
          </span>
        </el-form-item>
        <el-form-item label="申请说明">
          <el-input v-model="applyForm.remark" type="textarea" :rows="3" placeholder="请输入申请说明" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="applyDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="applySubmitting" @click="submitApply">提交申请</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProducts, createProduct, updateProduct, destroyProduct,
  setCloudProduct, cancelCloudProduct,
  getSelection, applySelection,
  getSelectionApplications, approveSelection, rejectSelection
} from '@/api'

export default {
  name: 'Products',
  data() {
    return {
      activeTab: 'products',
      selectionSubTab: 'library',

      // 当前操作的商品类型：1甄选 / 3臻赏 / 4爆品
      currentGoodsType: 1,

      // ========== 甄选商品列表 ==========
      searchKeyword: '',
      productList: [],
      productTotal: 0,
      productPage: 1,
      productLimit: 10,
      productLoading: false,

      // ========== 臻赏商品列表 ==========
      zhenshangSearchKeyword: '',
      zhenshangProductList: [],
      zhenshangProductTotal: 0,
      zhenshangProductPage: 1,

      // ========== 爆品商品列表 ==========
      baopinSearchKeyword: '',
      baopinProductList: [],
      baopinProductTotal: 0,
      baopinProductPage: 1,

      // ========== 托管商品列表（商品全部来自甄选专区）==========
      cloudSearchKeyword: '',
      cloudProductList: [],
      cloudProductTotal: 0,
      cloudProductPage: 1,

      // ========== 商品弹窗 ==========
      productDialogVisible: false,
      productDialogTitle: '新增甄选商品',
      productSubmitting: false,
      isEditing: false,
      editingId: null,
      productForm: {
        goods_name: '',
        cate_id: '',
        goods_img: '',
        goods_slide: '',
        detail_images: '',
        cost_price: 0,
        price: 0,
        original_price: 0,
        stock: 0,
        content: '',
        is_putaway: 1,
        is_baopin: 0,
        skus: []
      },
      productRules: {
        goods_name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        goods_img: [{ required: true, message: '请上传商品主图', trigger: 'change' }],
        cost_price: [{ required: true, message: '请输入成本价', trigger: 'blur' }],
        price: [{ required: true, message: '请输入售价', trigger: 'blur' }]
      },
      skuEnabled: false,
      skuSpecName1: '',
      skuSpecValues1: '',
      skuSpecName2: '',
      skuSpecValues2: '',
      categoryOptions: [],

      // ========== 详情弹窗 ==========
      detailDialogVisible: false,
      detailData: null,

      // ========== 选品库 ==========
      selectionList: [],
      selectionTotal: 0,
      selectionPage: 1,
      selectionLimit: 10,
      selectionLoading: false,

      // ========== 申请上架 ==========
      applyDialogVisible: false,
      applyTarget: null,
      applyForm: { ourRatio: 30, remark: '' },
      applySubmitting: false,

      // ========== 合作申请审核 ==========
      applicationList: [],
      applicationTotal: 0,
      applicationPage: 1,
      applicationLimit: 10,
      applicationLoading: false,
      auditStats: { pendingCount: 3, monthApprovedCount: 12 }
    }
  },
  computed: {
    uploadHeaders() {
      const token = localStorage.getItem('supplier_token')
      return token ? { Authorization: `Bearer ${token}` } : {}
    },
    slideImgList() {
      const src = this.productForm.goods_slide
      if (!src) return []
      if (Array.isArray(src)) return src
      return src.split(',').filter(u => u.trim())
    },
    detailImgList() {
      const src = this.productForm.detail_images
      if (!src) return []
      if (Array.isArray(src)) return src
      return src.split(',').filter(u => u.trim())
    },
    detailImages() {
      if (!this.detailData) return []
      // 优先从 detail_images 字段取，否则从 content 中提取 img 标签
      if (this.detailData.detail_images) {
        const src = this.detailData.detail_images
        if (Array.isArray(src)) return src
        return src.split(',').filter(u => u.trim())
      }
      const content = this.detailData.content || ''
      if (!content) return []
      const imgs = []
      const regex = /<img[^>]+src=["']([^"']+)["'][^>]*>/gi
      let match
      while ((match = regex.exec(content)) !== null) {
        imgs.push(match[1])
      }
      return imgs
    }
  },
  mounted() {
    this.fetchProducts()
    this.fetchCategoryOptions()
  },
  methods: {
    // ========== Tab切换 ==========
    handleTabChange(tab) {
      if (tab.name === 'selection') {
        if (this.selectionList.length === 0) this.fetchSelection()
        this.currentGoodsType = 1
      } else if (tab.name === 'zhenshang') {
        this.currentGoodsType = 3
        if (this.zhenshangProductList.length === 0) this.fetchZhenshangProducts()
      } else if (tab.name === 'baopin') {
        this.currentGoodsType = 4
        if (this.baopinProductList.length === 0) this.fetchBaopinProducts()
      } else if (tab.name === 'cloud') {
        // 托管商品全部来自甄选专区
        this.currentGoodsType = 1
        this.fetchCloudProducts()
      } else {
        this.currentGoodsType = 1
      }
    },

    // ========== 甄选商品列表 ==========
    fetchProducts() {
      this.productLoading = true
      const params = {
        page: this.productPage,
        limit: this.productLimit,
        goods_type: 1
      }
      if (this.searchKeyword) params.keyword = this.searchKeyword

      getProducts(params).then(res => {
        this.productList = res.list || res.data || []
        this.productTotal = res.total || 0
      }).catch(() => {
        this.$message.error('获取商品列表失败')
      }).finally(() => {
        this.productLoading = false
      })
    },

    // ========== 臻赏商品列表 ==========
    fetchZhenshangProducts() {
      this.productLoading = true
      const params = {
        page: this.zhenshangProductPage,
        limit: this.productLimit,
        goods_type: 3
      }
      if (this.zhenshangSearchKeyword) params.keyword = this.zhenshangSearchKeyword

      getProducts(params).then(res => {
        this.zhenshangProductList = res.list || res.data || []
        this.zhenshangProductTotal = res.total || 0
      }).catch(() => {
        this.$message.error('获取臻赏商品列表失败')
      }).finally(() => {
        this.productLoading = false
      })
    },

    // ========== 爆品商品列表 ==========
    fetchBaopinProducts() {
      this.productLoading = true
      const params = {
        page: this.baopinProductPage,
        limit: this.productLimit,
        goods_type: 4
      }
      if (this.baopinSearchKeyword) params.keyword = this.baopinSearchKeyword

      getProducts(params).then(res => {
        this.baopinProductList = res.list || res.data || []
        this.baopinProductTotal = res.total || 0
      }).catch(() => {
        this.$message.error('获取爆品商品列表失败')
      }).finally(() => {
        this.productLoading = false
      })
    },
    // ========== 托管商品列表（全部来自甄选专区）==========
    fetchCloudProducts() {
      this.productLoading = true
      const params = {
        page: this.cloudProductPage,
        limit: this.productLimit,
        goods_type: 1,
        is_cloud: 1
      }
      if (this.cloudSearchKeyword) params.keyword = this.cloudSearchKeyword

      getProducts(params).then(res => {
        this.cloudProductList = res.list || res.data || []
        this.cloudProductTotal = res.total || 0
      }).catch(() => {
        this.$message.error('获取托管商品列表失败')
      }).finally(() => {
        this.productLoading = false
      })
    },
    // 是否已设为托管商品
    isCloud(row) {
      return Number(row.is_cloud) === 1
    },
    handleSetCloud(row) {
      this.$confirm(`确认将「${row.goods_name}」设为托管商品？设置后该商品将展示在会员端云仓。`, '提示', { type: 'warning' }).then(() => {
        setCloudProduct({ id: row.id }).then(() => {
          this.$message.success('已设为托管商品')
          this.fetchProducts()
          this.fetchCloudProducts()
        }).catch(() => {
          this.$message.error('设置失败')
        })
      }).catch(() => { })
    },
    handleCancelCloud(row) {
      this.$confirm(`确认取消「${row.goods_name}」的托管？取消后会员端云仓将不再展示该商品。`, '提示', { type: 'warning' }).then(() => {
        cancelCloudProduct({ id: row.id }).then(() => {
          this.$message.success('已取消托管')
          this.fetchProducts()
          this.fetchCloudProducts()
        }).catch(() => {
          this.$message.error('取消失败')
        })
      }).catch(() => { })
    },
    // 刷新当前 Tab 对应商品列表
    refreshCurrentProducts() {
      if (this.currentGoodsType === 3) {
        this.fetchZhenshangProducts()
      } else if (this.currentGoodsType === 4) {
        this.fetchBaopinProducts()
      } else {
        this.fetchProducts()
      }
    },
    fetchCategoryOptions() {
      // 从 store 或 API 获取分类列表，这里简单处理
      // 实际应调用 getCategories API
    },

    // ========== 商品弹窗 ==========
    openProductDialog(mode, row) {
      const typeNameMap = { 1: '甄选', 3: '臻赏', 4: '爆品' }
      const typeName = typeNameMap[this.currentGoodsType] || '甄选'
      if (mode === 'add') {
        this.isEditing = false
        this.editingId = null
        this.productDialogTitle = '新增' + typeName + '商品'
        this.resetProductForm()
      } else if (mode === 'edit' && row) {
        this.isEditing = true
        this.editingId = row.id
        // 编辑时以商品自身的 goods_type 为准（甄选1 / 臻赏3 / 爆品4）
        if ([1, 3, 4].indexOf(Number(row.goods_type)) !== -1) {
          this.currentGoodsType = Number(row.goods_type)
        }
        this.productDialogTitle = '编辑' + (typeNameMap[this.currentGoodsType] || '甄选') + '商品'
        // 从 skus 中取第一个 SKU 的值作为价格体系默认值（Goods 模型的 price/market_price 是访问器，cost_price/stock 不在 goods 表里）
        const firstSku = (row.skus && row.skus.length > 0) ? row.skus[0] : null
        this.productForm = {
          goods_name: row.goods_name || '',
          cate_id: row.cate_id || '',
          goods_img: row.goods_img || '',
          goods_slide: row.goods_slide || '',
          detail_images: row.detail_images || row.content_images || '',
          cost_price: firstSku ? (firstSku.cost_price || 0) : (row.cost_price || 0),
          price: row.price || 0,
          original_price: firstSku ? (firstSku.market_price || firstSku.original_price || 0) : (row.original_price || 0),
          stock: firstSku ? (firstSku.stock || 0) : (row.stock || 0),
          content: row.content || '',
          is_putaway: row.is_putaway !== undefined ? row.is_putaway : 1,
          is_baopin: row.is_baopin ? 1 : 0,
          skus: (row.skus && row.skus.length > 0)
            ? row.skus.map(s => ({
              spec_name_text: s.spec_name_text || '默认',
              cost_price: s.cost_price || 0,
              price: s.price || 0,
              original_price: s.market_price || s.original_price || 0,
              stock: s.stock || 0
            }))
            : []
        }
        this.skuEnabled = this.productForm.skus.length > 0
      }
      this.productDialogVisible = true
    },
    resetProductForm() {
      this.productForm = {
        goods_name: '',
        cate_id: '',
        goods_img: '',
        goods_slide: '',
        detail_images: '',
        cost_price: 0,
        price: 0,
        original_price: 0,
        stock: 0,
        content: '',
        is_putaway: 1,
        is_baopin: 0,
        skus: []
      }
      this.skuEnabled = false
      this.skuSpecName1 = ''
      this.skuSpecValues1 = ''
      this.skuSpecName2 = ''
      this.skuSpecValues2 = ''
      this.isEditing = false
      this.editingId = null
      if (this.$refs.productForm) {
        this.$refs.productForm.resetFields()
      }
    },
    // 主图上传
    handleMainImgSuccess(response) {
      if (response.result === 'ok' && response.message) {
        this.productForm.goods_img = response.message
      }
    },
    // 轮播图上传
    handleSlideImgSuccess(response) {
      if (response.result === 'ok' && response.message) {
        const current = this.productForm.goods_slide
          ? this.productForm.goods_slide.split(',').filter(u => u.trim())
          : []
        current.push(response.message)
        this.productForm.goods_slide = current.join(',')
      }
    },
    removeSlideImg(idx) {
      const current = this.productForm.goods_slide.split(',').filter(u => u.trim())
      current.splice(idx, 1)
      this.productForm.goods_slide = current.join(',')
    },
    // 详情图上传
    handleDetailImgSuccess(response) {
      if (response.result === 'ok' && response.message) {
        const current = this.productForm.detail_images
          ? this.productForm.detail_images.split(',').filter(u => u.trim())
          : []
        current.push(response.message)
        this.productForm.detail_images = current.join(',')
      }
    },
    removeDetailImg(idx) {
      const current = this.productForm.detail_images.split(',').filter(u => u.trim())
      current.splice(idx, 1)
      this.productForm.detail_images = current.join(',')
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    submitProduct() {
      this.$refs.productForm.validate(valid => {
        if (!valid) return

        if (!this.productForm.goods_img) {
          this.$message.error('请上传商品主图')
          return
        }

        this.productSubmitting = true
        const data = {
          goods_name: this.productForm.goods_name,
          cate_id: this.productForm.cate_id,
          goods_img: this.productForm.goods_img,
          goods_slide: this.productForm.goods_slide,
          detail_images: this.productForm.detail_images,
          cost_price: this.productForm.cost_price,
          price: this.productForm.price,
          original_price: this.productForm.original_price,
          stock: this.productForm.stock,
          content: this.productForm.content,
          is_putaway: this.productForm.is_putaway,
          // 爆品(4)提交冗余爆品标志=1，其余类型一律=0（避免旧字段残留把甄选误标为爆品）
          is_baopin: this.currentGoodsType === 4 ? 1 : 0,
          goods_type: this.currentGoodsType,
          skus: this.skuEnabled ? JSON.parse(JSON.stringify(this.productForm.skus)) : []
        }

        const apiCall = this.isEditing
          ? updateProduct(this.editingId, data)
          : createProduct(data)

        apiCall.then(() => {
          this.$message.success(this.isEditing ? '更新成功' : '创建成功')
          this.productDialogVisible = false
          this.refreshCurrentProducts()
        }).catch(() => {
          this.$message.error(this.isEditing ? '更新失败' : '创建失败')
        }).finally(() => {
          this.productSubmitting = false
        })
      })
    },
    generateSkuList() {
      const values1 = this.skuSpecValues1.split(',').map(v => v.trim()).filter(v => v)
      const values2 = this.skuSpecValues2.split(',').map(v => v.trim()).filter(v => v)
      const name1 = this.skuSpecName1.trim()
      const name2 = this.skuSpecName2.trim()

      if (values1.length === 0) {
        this.$message.warning('请输入规格1的值')
        return
      }

      // 使用价格体系的值作为 SKU 默认值
      const defaultCostPrice = this.productForm.cost_price || 0
      const defaultPrice = this.productForm.price || 0
      const defaultOriginalPrice = this.productForm.original_price || 0
      const defaultStock = this.productForm.stock || 0

      const skus = []
      if (values2.length > 0) {
        values1.forEach(v1 => {
          values2.forEach(v2 => {
            skus.push({
              spec_name_text: `${name1 ? name1 + ':' : ''}${v1} ${name2 ? name2 + ':' : ''}${v2}`,
              cost_price: defaultCostPrice,
              price: defaultPrice,
              original_price: defaultOriginalPrice,
              stock: defaultStock
            })
          })
        })
      } else {
        values1.forEach(v1 => {
          skus.push({
            spec_name_text: `${name1 ? name1 + ':' : ''}${v1}`,
            cost_price: defaultCostPrice,
            price: defaultPrice,
            original_price: defaultOriginalPrice,
            stock: defaultStock
          })
        })
      }
      this.productForm.skus = skus
    },
    handleDelete(row) {
      this.$confirm(`确认删除商品「${row.goods_name}」？`, '提示', { type: 'warning' }).then(() => {
        destroyProduct(row.id).then(() => {
          this.$message.success('删除成功')
          this.refreshCurrentProducts()
        }).catch(() => {
          this.$message.error('删除失败')
        })
      }).catch(() => { })
    },

    // ========== 详情弹窗 ==========
    openDetailDialog(row) {
      this.detailData = { ...row }
      this.detailDialogVisible = true
    },
    previewDetailImage(url) {
      // 使用 el-image 的预览功能，这里简单用 window.open
      window.open(url, '_blank')
    },

    // ========== 审核状态 ==========
    auditStatusType(status) {
      const map = { 0: 'warning', 1: 'success', 2: 'danger', 3: 'info' }
      return map[status] || 'info'
    },
    auditStatusText(status) {
      const map = { 0: '待审核', 1: '已通过', 2: '已驳回', 3: '已下架' }
      return map[status] || '未知'
    },

    // ========== 选品库 ==========
    fetchSelection() {
      this.selectionLoading = true
      const params = { page: this.selectionPage, limit: this.selectionLimit }
      getSelection(params).then(res => {
        this.selectionList = res.list || res.data || []
        this.selectionTotal = res.total || 0
      }).catch(() => {
        this.$message.error('获取选品库列表失败')
      }).finally(() => {
        this.selectionLoading = false
      })
    },
    selectionStatusType(status) {
      const map = { 0: 'info', 1: 'success' }
      return map[status] || 'info'
    },
    selectionStatusText(status) {
      const map = { 0: '可申请', 1: '已上架' }
      return map[status] || '未知'
    },

    // ========== 申请上架 ==========
    openApplyDialog(row) {
      this.applyTarget = row
      this.applyForm = { ourRatio: 30, remark: '' }
      this.applyDialogVisible = true
    },
    submitApply() {
      if (!this.applyTarget) return
      this.applySubmitting = true
      const data = {
        selection_id: this.applyTarget.id,
        our_ratio: this.applyForm.ourRatio,
        their_ratio: (100 - this.applyForm.ourRatio).toFixed(1),
        remark: this.applyForm.remark
      }
      applySelection(data).then(() => {
        this.$message.success('申请已提交')
        this.applyDialogVisible = false
        this.fetchSelection()
      }).catch(() => {
        this.$message.error('申请失败')
      }).finally(() => {
        this.applySubmitting = false
      })
    },

    // ========== 合作申请审核 ==========
    fetchApplications() {
      this.applicationLoading = true
      const params = { page: this.applicationPage, limit: this.applicationLimit }
      getSelectionApplications(params).then(res => {
        this.applicationList = res.list || res.data || []
        this.applicationTotal = res.total || 0
        this.auditStats = {
          pendingCount: res.pendingCount || res.pending_count || 0,
          monthApprovedCount: res.monthApprovedCount || res.month_approved_count || 0
        }
      }).catch(() => {
        this.$message.error('获取申请列表失败')
      }).finally(() => {
        this.applicationLoading = false
      })
    },
    applicationStatusType(status) {
      const map = { 0: 'warning', 1: 'success', 2: 'danger' }
      return map[status] || 'info'
    },
    applicationStatusText(status) {
      const map = { 0: '待审核', 1: '已通过', 2: '已驳回' }
      return map[status] || '未知'
    },
    handleApprove(row) {
      this.$confirm(`确认通过「${row.goods_name}」的上架申请？`, '提示', { type: 'warning' }).then(() => {
        approveSelection({ id: row.id }).then(() => {
          this.$message.success('已通过申请')
          this.fetchApplications()
        }).catch(() => {
          this.$message.error('操作失败')
        })
      }).catch(() => { })
    },
    handleReject(row) {
      this.$confirm(`确认驳回「${row.goods_name}」的上架申请？`, '提示', { type: 'warning' }).then(() => {
        rejectSelection({ id: row.id }).then(() => {
          this.$message.success('已驳回申请')
          this.fetchApplications()
        }).catch(() => {
          this.$message.error('操作失败')
        })
      }).catch(() => { })
    }
  }
}
</script>

<style scoped>
.products {
  padding: 4px;
}

.products-tabs {
  border-radius: 8px;
  overflow: hidden;
}

/* 搜索栏 */
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  gap: 12px;
}

.toolbar-left {
  display: flex;
  gap: 12px;
}

.toolbar-right {
  display: flex;
  gap: 12px;
}

/* 分页 */
.pagination-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0 0;
  font-size: 13px;
  color: #909399;
}

/* 价格颜色 */
.price-red {
  color: #3a8ee6;
  font-weight: bold;
}

/* 二级 Tab */
.sub-tabs {
  margin-bottom: 16px;
  padding: 16px 0 0;
}

/* 蓝色提示条 */
.info-banner {
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.info-banner i {
  color: #409EFF;
  font-size: 18px;
  margin-top: 2px;
}

.info-banner p {
  margin: 0;
  font-size: 13px;
  color: #4a90e2;
  line-height: 1.6;
}

/* 审核统计卡片 */
.audit-stats {
  margin-bottom: 16px;
}

.audit-stat-card {
  padding: 20px;
  border-radius: 8px;
  border: 1px solid;
}

.audit-stat-orange {
  background: #fdf6ec;
  border-color: #faecd8;
}

.audit-stat-green {
  background: #f0f9eb;
  border-color: #e1f3d8;
}

.audit-stat-label {
  font-size: 13px;
  color: #909399;
  margin: 0 0 8px;
}

.audit-stat-value {
  font-size: 28px;
  font-weight: bold;
  margin: 0;
}

.audit-stat-orange .audit-stat-value {
  color: #E6A23C;
}

.audit-stat-green .audit-stat-value {
  color: #67c23a;
}

/* 商品表单 */
/* 主图上传 */
.upload-img-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.main-img-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.main-img-uploader:hover {
  border-color: #C91623;
}

.main-img-preview {
  width: 120px;
  height: 120px;
  object-fit: cover;
}

.main-img-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.upload-tip {
  font-size: 12px;
  color: #909399;
}

/* 轮播图 & 详情图 上传 */
.slide-imgs-section,
.detail-imgs-section {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.slide-img-item,
.detail-img-item {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e4e7ed;
}

.slide-img-preview,
.detail-img-preview {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.slide-img-actions,
.detail-img-actions {
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 24px;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0 6px 0 6px;
}

.slide-img-actions i,
.detail-img-actions i {
  color: #fff;
  font-size: 14px;
}

.slide-img-uploader,
.detail-img-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slide-img-uploader:hover,
.detail-img-uploader:hover {
  border-color: #C91623;
}

.slide-img-uploader-icon,
.detail-img-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

/* 爆品提示 */
.baopin-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
  margin-top: 4px;
}

/* 臻赏 1折 提示 */
.zhenshang-price-tip {
  background: #fdf6ec;
  border: 1px solid #faecd8;
  color: #e6a23c;
  font-size: 12px;
  line-height: 1.6;
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 16px;
}

.zhenshang-price-tip strong {
  color: #e6a23c;
}

/* 托管商品说明横幅 */
.cloud-banner {
  background: #fdf6ec;
  border-color: #faecd8;
}

.cloud-banner i {
  color: #e6a23c;
}

.cloud-banner p {
  color: #b88230;
}

/* 臻赏说明横幅 */
.zhenshang-banner {
  background: #f0f9eb;
  border-color: #e1f3d8;
}

.zhenshang-banner i {
  color: #67c23a;
}

.zhenshang-banner p {
  color: #529b2e;
}

/* SKU区域 */
.sku-section {
  background: #f5f7fa;
  border-radius: 8px;
  padding: 16px;
}

/* 详情弹窗 */
.detail-wrap {
  font-size: 14px;
}

.detail-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  line-height: 1.8;
}

.detail-label {
  color: #909399;
  flex-shrink: 0;
  width: 90px;
}

/* 无操作 */
.no-action {
  color: #c0c4cc;
  font-size: 12px;
}

/* 详情弹窗 - 图片画廊 */
.detail-images-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
}

.detail-gallery-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  cursor: pointer;
}

.detail-gallery-img:hover {
  border-color: #C91623;
}
</style>
